export enum PostVideoType {
    None = 0,
    YouTube = 1,
    Vimeo = 2
}

export interface IPost {
    id?: string;
    userId?: string;
    groupId?: string | null;
    groupIds?: string[] | null;
    communityIds?: string[] | null;
    content?: string;
    author?: string;
    imageFile?: string | null;
    postDate?: Date | string | number | null;
    createdAt?: Date | string | number | null;
    videoLink?: string | null;
    videoType?: PostVideoType | number;
    publicPost?: boolean;
    publishOnNostr?: boolean;
}

export interface IPostUpsert {
    id?: string;
    groupId?: string | null;
    groupIds?: string[] | null;
    communityIds?: string[] | null;
    content: string;
    currentImageFile?: string | null;
    imageFile?: File | null;
    publicPost: boolean;
    publishOnNostr: boolean;
    videoType: PostVideoType;
    videoLink?: string | null;
}
